import React from 'react';
import { XIcon } from 'lucide-react';
interface CartItemProps {
  item: {
    id: string;
    khatianNo: string;
    dagNo: string;
    ownerName: string;
    area: string;
    moujaName: string;
  };
  onRemove: () => void;
}
export const CartItem = ({
  item,
  onRemove
}: CartItemProps) => {
  return <div className="bg-white border rounded-lg p-3 shadow-sm" data-id="element-128">
      <div className="flex justify-between items-start" data-id="element-129">
        <div data-id="element-130">
          <div className="flex items-center" data-id="element-131">
            <span className="font-medium" data-id="element-132">খতিয়ান নং:</span>
            <span className="ml-2" data-id="element-133">{item.khatianNo}</span>
          </div>
          <div className="text-sm text-gray-600 mt-1" data-id="element-134">
            <div data-id="element-135">
              <span data-id="element-136">ডাগ নং:</span>
              <span className="ml-2" data-id="element-137">{item.dagNo}</span>
            </div>
            <div data-id="element-138">
              <span data-id="element-139">মালিক:</span>
              <span className="ml-2" data-id="element-140">{item.ownerName}</span>
            </div>
            <div data-id="element-141">
              <span data-id="element-142">এলাকা:</span>
              <span className="ml-2" data-id="element-143">{item.area}</span>
            </div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-144">{item.moujaName}</div>
          </div>
        </div>
        <button className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full" onClick={onRemove} aria-label="অপসারণ করুন (Remove)" data-id="element-145">
          <XIcon className="h-4 w-4" data-id="element-146" />
        </button>
      </div>
    </div>;
};